import borderColor from './border-color';

export default { borderColor };
